export default ({ request }) => ({
  // 获取租户用户列表
  getTenantUsersList(params) {
    return request({
      url: '/v1/tenant/users/list',
      method: 'get',
      params: params
    })
  },

  // 获取所有租户列表（超管专用）
  getTenantUsersTenants() {
    return request({
      url: '/v1/tenant/users/tenants/all',
      method: 'get'
    })
  },

  // 获取租户用户详情
  getTenantUserDetail(id) {
    return request({
      url: `/v1/tenant_users/${id}`,
      method: 'get'
    })
  },

  // 创建租户用户
  createTenantUser(data) {
    return request({
      url: '/v1/tenant/users',
      method: 'post',
      data: data
    })
  },

  // 更新租户用户
  updateTenantUser(id, data) {
    return request({
      url: `/v1/tenant/users/${id}`,
      method: 'put',
      data: data
    })
  },

  // 删除租户用户
  deleteTenantUser(id) {
    return request({
      url: `/v1/tenant/users/${id}`,
      method: 'delete'
    })
  },

  // 重置用户密码
  resetUserPassword(userId, data) {
    return request({
      url: `/v1/tenant/users/${userId}/password/reset`,
      method: 'put',
      data: data
    })
  },

  // 分配角色给用户
  assignRole(userId, data) {
    return request({
      url: `/v1/tenant/users/${userId}/role`,
      method: 'put',
      data: data
    })
  },

  // Get users by tenant ID (super admin)
  get_users_by_tenant(tenantId, params) {
    return request({
      url: '/v1/tenant/users/list',
      method: 'get',
      params: { ...params, tenant_id: tenantId }
    })
  },

  // Create tenant user for specific tenant (super admin)
  create_tenant_user_for_tenant(data) {
    return request({
      url: '/v1/tenant/users',
      method: 'post',
      data: data
    })
  }
})